<script lang="ts">
  import { css } from '@agapi/ui/panda/css';
  import { marked } from 'marked';
  import { styledMarkdown } from './markdown.styles';
  import type { SystemStyleObject } from '@agapi/ui/panda/types';

  // TODO: Is it possible to use text from child?
  // const { children }: { children: Snippet } = $props();
  const { value, css: cssProp }: { value: string; css?: SystemStyleObject } = $props();
</script>

{#if value}
  <span class={css(styledMarkdown, cssProp)}>
    {@html marked(value)}
  </span>
{/if}
